import React, { useEffect, useState, useRef } from 'react'
import styled from '@emotion/styled'
import { Button, Menu } from '@mantine/core'
import { IconMaps } from '@ow/icons'
import { fieldTypes } from '../constant'
import FieldConfig from './FieldConfig'
import emptyImg from './assets/empty_status.png'

const FieldsEditorBox = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .contain-title {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    position: relative;
  }

  .field-set-list {
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 0;
    overflow: auto;
    padding: 0 20%;
  }

  .contain-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    height: 64px;
    border-top: 1px solid var(--ow-color-neutral-400);
    width: 100%;
  }

  .bottom-btn {
    height: 32px;
    font-weight: normal;
    padding: 0 15px;
  }

  .btn-outline {
    color: var(--ow-color-gray-100);
    border-color: var(--ow-color-neutral-400);
  }

  .btn-primary {
    color: white;
    background-color: var(--ow-color-primary-700);
  }

  .shift-contain {
    position: absolute;
    right: 0;
    border-radius: 4px;
    transition: 0.3s;
    .shift-text {
      padding: 0 10px;
      color: #000;
    }
    .mantine-ActionIcon-root {
      color: #000;
    }
    &:hover {
      background: #ecf2fe;
      .mantine-ActionIcon-root {
        color: var(--ow-color-primary-700);
      }
      .shift-text {
        color: var(--ow-color-primary-700);
      }
    }

    .field-li {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 40px;
      margin: 4px 8px;
      width: calc(100% - 16px);
      border-radius: 4px;
      transition: 0.3s;
      cursor: pointer;

      &.acitve-li {
        color: #fff;
        background: var(--ow-color-primary-700);

        &:hover {
          background: var(--ow-color-primary-700);
        }
      }

      &:hover {
        background: var(--ow-color-neutral-100);
      }
    }
  }
  .empty-status {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    .empty-image {
      height: 260px;
      min-width: 300px;
      margin-bottom: 60px;
    }
  }
`
/**
 * 字段编辑组件
 * @param {string} className 样式
 * @param {array} fieldList 字段列表
 * @param {number} curFieldIndex 当前编辑索引
 * @param {function} onSaveField 点击保存字段时执行的函数
 * @param {function} onDeleteField 点击删除字段时执行的函数
 * @param {function} onChangeType 点击修改类型字段时执行的函数
 * @param {function} onInfoDirty 表单编辑了内容后执行的函数
 * @param {function} onBindOther 绑定其他字段
 * @returns
 */
const fieldsEditor = ({
  className,
  fieldList,
  createFieldFilter,
  curFieldIndex,
  onSaveField,
  onDeleteField,
  onChangeType,
  onInfoDirty,
  onBindOther,
}) => {
  let fieldTypesList = fieldTypes
  if (createFieldFilter) {
    fieldTypesList = fieldTypes.filter((e) =>
      createFieldFilter.includes(e.type)
    )
  }

  const [field, setField] = useState()
  const [currentIndex, setCurrentIndex] = useState()
  const formRef = useRef()
  useEffect(() => {
    if (fieldList && fieldList[curFieldIndex]) {
      setField(fieldList[curFieldIndex])
      setCurrentIndex(
        fieldTypes.findIndex((e) => e.type === fieldList[curFieldIndex].type)
      )
    }
  }, [curFieldIndex, fieldList])

  return field ? (
    <FieldsEditorBox className={className}>
      <div className="contain-title ">
        <span>设置表单项</span>
        <div className="shift-contain">
          <Menu width={200}>
            <Menu.Target>
              <div className="shift-text cursor-pointer flex items-center ">
                <span>切换类型</span>
                <IconMaps type="shiftIcon" />
              </div>
            </Menu.Target>
            <Menu.Dropdown>
              {fieldTypesList.map((item, i) => (
                <Menu.Item
                  type={null}
                  key={`${item.type}-${i}`}
                  className={`field-li ${
                    currentIndex === i ? 'acitve-li' : ''
                  }`}
                  component="div"
                  icon={
                    currentIndex === i ? item.icon('white') : item.icon('black')
                  }
                  onClick={() => {
                    onChangeType(fieldTypes[i])
                    setField(fieldList[curFieldIndex])
                    // setCurrentIndex(i)
                  }}
                >
                  <span>{item.title}</span>
                </Menu.Item>
              ))}
            </Menu.Dropdown>
          </Menu>
        </div>
      </div>
      <FieldConfig
        className="field-set-list"
        field={field}
        ref={formRef}
        onInfoDirty={onInfoDirty}
      />

      <div className="contain-bottom">
        <div>
          {onBindOther && (
            <Button
              variant="outline"
              className="bottom-btn btn-outline"
              onClick={onBindOther}
            >
              绑定其他字段
            </Button>
          )}
        </div>
        <div>
          {onDeleteField && (
            <Button
              variant="outline"
              className="bottom-btn btn-outline"
              onClick={() => {
                onDeleteField(field)
              }}
            >
              删除
            </Button>
          )}
          <Button
            type="primary"
            className="bottom-btn btn-primary ml-2"
            onClick={() => {
              formRef.current.trigger().then((res) => {
                if (res) {
                  const newFieldInfo = formRef.current.getValues()
                  onSaveField(newFieldInfo)
                }
              })
            }}
          >
            保存
          </Button>
        </div>
      </div>
    </FieldsEditorBox>
  ) : (
    <FieldsEditorBox className={className}>
      <div className="empty-status">
        <img className="empty-image" src={emptyImg} alt="" />
        <span>您可以选中某个字段进行设置</span>
      </div>
    </FieldsEditorBox>
  )
}

export default fieldsEditor
